import objectToFormData from 'object-to-formdata'

export default class formExt {
    static postForm (obj, url, iframe) {
        return new Promise(resolve => {
            let formData = objectToFormData(obj, { indices: true })
            let data = {}
            for (var pair of formData.entries()) {
                data[pair[0]] = pair[1]
            }

            // var iframe = document.getElementById('iframeDownload') ? document.getElementById('iframeDownload') : document.createElement('iframe')
            // iframe.style.display = 'none'
            // iframe.src = 'javascript:false;'
            // iframe.name = 'iframeDownload'
            // iframe.id = 'iframeDownload'
            // document.body.appendChild(iframe)

            var f = document.createElement('form')
            f.target = iframe
            f.method = 'POST'
            f.style.display = 'none'
            f.action = url

            f.innerHTML = Object.keys(data)
                .map(k => `<input type="hidden" name="${k}" value="${data[k] !== null && data[k] !== undefined ? data[k] : ''}" />`)
                .join('')

            document.getElementById(iframe).onload = resolve

            document.body.appendChild(f)
            f.submit()
            document.body.removeChild(f)
        })
    }
}
